import axiosInstance from './';
import Storage from '../helpers/storage';
import env from '../config/env';

export default class {
  constructor() {
    this.instance = axiosInstance(env.REACT_APP_MKTP_ENDPOINT);
  }

  getServices = () =>
    this.instance({
      url: `/unities/${Storage.getLocalStorageMerchant().idUnity}?style=catalog`,
      method: 'GET',
    });
}



// WEBPACK FOOTER //
// ./src/services/Merchant.js